import { Alert, Box, Button } from '@mui/material'

export default function WorkspaceGateError({ onRetry }) {
  return (
    <Box sx={{ p: 4, maxWidth: 480, mx: 'auto' }}>
      <Alert severity="error" sx={{ mb: 2 }}>
        Could not load workspaces. Check your connection and try again.
      </Alert>
      <Button variant="contained" onClick={onRetry}>
        Retry
      </Button>
    </Box>
  )
}
